<!-- <h2 mat-dialog-title>{{ 'teamMember' | translate}}</h2> -->

<mat-dialog-content class="team-member-form-dialog-content">
  <tm-team-member-form #memberForm [team]="data.team" 
                                   [member]="data.member" 
                                   (onSubmit)="create()"
                                   (onUpdate)="onMemberChanged.next($event)"></tm-team-member-form>
</mat-dialog-content>

<mat-dialog-actions>

  <!-- delete button -->
  @if (memberForm.isUpdate && memberForm.memberId !== currentUser?.id) {
    <button type="button" class="btn btn-danger"
      (click)="delete()"
      data-cy="delete-teammember-btn">{{ (memberForm.hasMultipleTeams && memberForm.memberId !== currentUser?.id ? 'multiple_teams_user_deletation' : 'delete') |
    translate}}</button>
  }

  <!-- close button -->
  <button type="button" class="btn btn-default"
    data-cy="close-teammember-btn" (click)="close()">{{ (memberForm.isUpdate ? 'close' : 'cancel') |
  translate}}</button>

  <!-- create button -->
  @if (!memberForm.isUpdate) {
    <button type="submit" [disabled]="memberForm.form.invalid"
      data-cy="submit-teammember-btn" class="btn btn-primary px-4"
    (click)="create()">Ok</button>
  }

</mat-dialog-actions>